import React from "react";
import Lottie from "react-lottie";
import animationData from "./File_lottie.json";
import "./File_lottie.css";
function File_lottie() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <section className="File_lottie">
          <div className="File_lottie_animation">
            <Lottie
              className="me-auto "
              options={defaultOptions}
            />
          </div>
    </section>
  );
}
export default File_lottie;
